﻿import React, { useState, useEffect, Fragment } from 'react';
import * as IProduct from '../Interfaces';
import ImageGallery from 'react-image-gallery';
import { ProductSelector, Price, ProductBuyer } from './Components';
import { ProductProps } from './Interfaces';
import { Popover } from 'react-tiny-popover'
import { SimplePopover } from '../../../components/SimplePopover';

export function ProductPage(props: ProductProps) {
    const [id, setId] = useState(props.product.variants[0].id);
    const [detail, setDetail] = useState<IProduct.ProductPage>(null);
    const [showTooltip, setShowTooltip] = useState<number>(0);
    const [tooltipClearByClick, setTooltipClearByClick] = useState(false);
    
    useEffect(() => {
        (async function fetchProductPage() {
            const response = await fetch(`/Shop/ProductPage/${props.product.id}?tag=${props.product.tag}`, {
                method: 'GET',
                mode: 'same-origin',
                credentials: 'same-origin',
                headers: {
                    'Content-Type': 'application/json'
                },
                redirect: "follow"
            });
            const productDetail = (await response.json()) as IProduct.ProductPage;
            setDetail(productDetail);
        }) ();
    }, []);

    const variant = props.product.variants.find(x => x.id === id);
    const ordered = props.cart.products.find(x => x.productVariantId === id)?.quantity ?? 0;

    function variantSelected(id: number) {
        const selected = props.product.variants.find(x => x.id === id);

        setId(selected.id);
    }

    function qtyChanged(qty: number) {
        props.itemCountChanged(props.product.id, id, qty);
    }

    const images = detail?.images.map(x => { return { original: `/Images/520x520/${x}?fmt=lossy`, thumbnail: `/Images/c256x144/${x}?fmt=lossy` } });

    const hasInfo = detail?.growingMethod || detail?.growingLocation || detail?.shelfLife || detail?.storage;
    const hasRecipe = detail?.recipeTitle && detail?.recipeUrl;

    const badges = props.product.badges.map(x => props.badges.find(y => y.id === x));

    return (
        <div className="container">
            <div className="product-page row">
                <div className="col-12 col-lg mb-3 mr-md-3 pl-0 pr-0" id="p-details">
                    <div className="bg-white p-3">
                        <div className={detail?.description ? 'clearfix gallery-desc' : 'clearfix'}>
                            {detail?.images && detail?.images.length > 0 ? <div className="gallery-wrapper"><ImageGallery items={images} showFullscreenButton={false} infinite={false} showPlayButton={false} showThumbnails={detail.images.length > 1} thumbnailPosition={"bottom"} additionalClass="mb-3" /></div> : null}
                            {detail?.description ? <div className="ugm" dangerouslySetInnerHTML={{ __html: detail.description }} /> : null}
                        </div>

                        {detail?.hubNote ? (<Fragment>
                            <h4>Hub Note</h4>
                            <div className="ugm" dangerouslySetInnerHTML={{ __html: detail.hubNote }} />
                        </Fragment>) : null}

                        <div>
                            {badges.map(x => (<Popover isOpen={showTooltip === x.id} positions={['top', 'right', 'bottom', 'left']} content={<SimplePopover markup={`<h5>${x.name}</h5>${x.description}`} className="p-2" />} padding={6} onClickOutside={() => {  setShowTooltip(0); }}>
                                <span className="badge badge-info mr-1 cursor-default" onMouseOver={() => { setShowTooltip(x.id); }} onTouchStart={() => setTooltipClearByClick(true)} onMouseOut={() => { if (!tooltipClearByClick) { setShowTooltip(0); } }}>{x.name}</span>
                            </Popover>))}
                        </div>

                        {hasInfo ? (<dl>
                            {detail?.growingMethod ? <Fragment><dt>Growing Method</dt><dd>{detail.growingMethod}</dd></Fragment> : null}
                            {detail?.growingLocation ? <Fragment><dt>Growing Location</dt><dd>{detail.growingLocation}</dd></Fragment> : null}                
                            {detail?.growingMethod ? <Fragment><dt>Storage</dt><dd>{detail.storage}</dd></Fragment> : null}
                            {detail?.shelfLife ? <Fragment><dt>Shelf Life</dt><dd>{detail.shelfLife}</dd></Fragment> : null}
                        </dl>) : null}

                        {hasRecipe ? <p className="mb-0">Recipe: <a href={detail.recipeUrl} target='_blank'>{detail.recipeTitle}</a></p> : null}
                    </div>
                </div>
            
                <div className="col-12 col-md-8 col-lg-auto product mb-3 pl-0 pr-0" id="p-purchase">
                    <div className="p-info">
                        <h4 className="p-title">{props.product.name}</h4>
                        <span className="p-supplier">{props.product.supplier}</span>

                        <ProductSelector product={props.product} variant={variant} variantSelected={variantSelected} />

                        <div className="flex-grow-1">
                        </div>

                        <Price product={props.product} variant={variant} />

                        <div className="p-buy">
                            <ProductBuyer qty={ordered} setQty={qtyChanged} inStock={props.product.inStock} canEdit={props.cart.status === 'Active'} shopOpen={props.shopOpen} loggedIn={props.loggedIn} preview={props.product.preview} />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}